module.exports = __webpack_public_path__ + "assets/images/lexiang.3f812982a0c4dec9f388960117aa6784.png";